import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../utils/api';
import toast from 'react-hot-toast';

export default function MLCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const save = async () => {
      const access_token = params.get('access_token');
      const refresh_token = params.get('refresh_token');
      const expires_at = params.get('expires_at');
      const ml_user_id = params.get('ml_user_id');

      if (!access_token) { navigate('/configuracion?error=no_token'); return; }

      try {
        await auth.mlSaveToken({ access_token, refresh_token, expires_at, ml_user_id });
        toast.success('Mercado Libre conectado exitosamente!');
        navigate('/dashboard');
      } catch (err) {
        toast.error('Error guardando token de ML');
        navigate('/configuracion');
      }
    };
    save();
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#f5f5ef',
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      gap: 16
    }}>
      <div style={{
        width: 48, height: 48, borderRadius: 14,
        background: '#ede9fe',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7c5ef8" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M8 12l2 2 4-4"/>
        </svg>
      </div>
      <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>
        Conectando con Mercado Libre...
      </div>
      <div style={{ fontSize: 13, color: '#aaa' }}>
        Por favor espera un momento
      </div>
    </div>
  );
}
